import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, take } from 'rxjs/operators';

import { EventsActions } from './events.actions';
import { CachedUserDetails, END_OF_LIST } from './events.model';
import { EventsSelectors } from './events.selectors';

@Injectable({ providedIn: 'root' })
export class EventsStore {
  state$ = this.store.select(EventsSelectors.getState());
  cursor$ = this.store.select(EventsSelectors.getCursor());
  events$ = this.store.select(EventsSelectors.getEvents());
  filters$ = this.store.select(EventsSelectors.getFilters());
  dateFilter$ = this.store.select(EventsSelectors.getDateFilter());
  cachedUsers$ = this.store.select(EventsSelectors.getCachedUsers());
  isDownloadFileInGeneration$ = this.store.select(
    EventsSelectors.selectIsDownloadFileBeingGenerated
  );

  constructor(private store: Store) {}

  loadEvents(): void {
    this.state$
      .pipe(
        take(1),
        filter((state) => state.cursor !== END_OF_LIST)
      )
      .subscribe(() => {
        this.store.dispatch(EventsActions.loadEvents());
      });
  }

  updateFilters(filters: string[], dateFilter: string): void {
    this.store.dispatch(EventsActions.updateFilters({ filters, dateFilter }));
  }

  resetSubscriptions(): void {
    this.store.dispatch(EventsActions.resetEvents());
  }

  loadUserDetails(uuid: string): void {
    this.state$
      .pipe(
        first(),
        filter((state) => !state.cachedUsersIds.includes(uuid))
      )
      .subscribe(() => {
        this.store.dispatch(EventsActions.loadUserDetails({ uuid }));
      });
  }

  getCachedUsername(uuid: string): Observable<string> {
    return this.store.select(EventsSelectors.getCachedUsername(uuid));
  }

  getCachedUser(uuid: string): Observable<CachedUserDetails> {
    return this.store.select(EventsSelectors.getCachedUser(uuid));
  }

  triggerEventLogFileGeneration(): void {
    this.store.dispatch(EventsActions.triggerEventLogFileGeneration.attempt());
  }

  clearEventLogDownloadData(): void {
    this.store.dispatch(EventsActions.triggerEventLogFileGeneration.cleanup());
  }
}
